<template>
  <el-dialog
    v-if="isVisible"
    v-model="isVisible"
    class="order-test"
    append-to-body
    @close="close"
  >
    <template v-slot:header>
      <div class="flex items-center warning-header">
        <img src="@/assets/orderTest/covid_alert.svg" alt="warning">
        <p class="ml-6">{{ $t("OrderPage[\"Warning\"]") }}</p>
      </div>
    </template>
    <div class="py-6 pl-6 pr-10">
      <div class="break-words">{{ text }}</div>
      <div class="mt-6 flex justify-end">
        <el-button class="warning-cancel-btn" @click="close">{{ $t("OrderPage[\"Cancel\"]") }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
  }
}
</script>

<style scoped>
.warning-header {
  font-weight: 600;
  font-size: 21px;
  line-height: 25px;
}
.warning-cancel-btn {
  width: 90px;
  height: 41px;
  
  background: #E6E6E6;
  border-radius: 4px;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #4A4A4A;
}
</style>